export default __webpack_public_path__ + "static/media/r5.1d41b741.jpg";